import React from 'react'

function Navbar() {
  return (
    <>
        <nav className="navbar navbar-expand-lg">
  <div className="container-fluid">
  <a className="navbar-brand" href="#">
        <img src={`${process.env.PUBLIC_URL}/logo2.png`} className="logo" />
      </a>
    <button className="navbar-toggler navbar-toggler-custom" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo01" aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarTogglerDemo01">
     
      <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="#">Home</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="#about-section">About Us</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="#services">Our Services</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="#contact">Contact Us</a>
        </li>
        
      </ul>
      
    </div>
  </div>
</nav>
    </>
  )
}

export default Navbar